import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const NISStatusWrapper = styled.div`
  .status-label {
    margin: 24px 16px;

    ${responsive.MOBILE`
      margin: 0px 8px 16px 8px;
    `}
  }

  .active-change-status {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .MuiGrid2-root {
    padding-right: 0px !important;
  }
`;
